import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import data from "./assets/apiRoutes.json";
import sitelogo from "./assets/logo.png";
import userImage1 from "./assets/user1.png";
import userImage2 from "./assets/user2.png";
import axios from "axios";
import * as ReduxOidc from "redux-oidc";
import configuration from "./configuration";
import { Menu } from 'devextreme-react/menu';
import { Popup } from 'devextreme-react/popup';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import "./Header.css"
import { SelectBox } from "devextreme-react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import service from './Localization.js';
import { locale, loadMessages, formatMessage } from 'devextreme/localization';
import {AppSettingsLocalStorageKey} from "./const/constants";
import { clearAllChatMessages } from "./common/Utils";
import { clearAllSearchStates } from "./common/SearchStatePersistence";
import { buildBreadcrumbFromRoute } from "./common/BreadcrumbUtils";
const selectBoxInputAttr = { id: 'selectInput' };
locale(sessionStorage.getItem('locale') || 'en');
loadMessages(service.getDictionary());
const Header = (props) => {
  var oidc = props.oidc;
  const [localeState, setLocaleState] = useState(sessionStorage.getItem('locale') || 'en');
  const locales = service.getLocales();
  const changeLocale = (e) => {
    sessionStorage.setItem('locale', e.value);
    setLocaleState(e.value);
    document.location.reload();
  };
  var accessToken = props.oidc.user.access_token;
  const [menuVisible, setMenuVisible] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [version, setVersion] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [selectedFacility, setSelectedFacility] = useState("-1");
  const [isMobileView, setIsMobileView] = useState(false);
      const [settings, setSettings] = useState({
          AppTitle: "",
          AppIcon: "",
          AppLogo: "",
          LoginBackground: "",
          NoImage:false,
      });
  const menuRef = useRef(null);
  const selectBoxRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const [breadcrumbItems, setBreadcrumbItems] = useState(() => buildBreadcrumbFromRoute(location.pathname));
  
  // Update breadcrumb when location changes
  useEffect(() => {
    const items = buildBreadcrumbFromRoute(location.pathname);
    setBreadcrumbItems(items);
    
    // For ViewDashboard page, fetch dashboard title from API and update breadcrumb
    if (location.pathname === '/db/ViewDashboard') {
      const urlParams = new URLSearchParams(location.search);
      const rowid = urlParams.get('rowid');
      
      if (rowid) {
        // Try to get dashboard title from API
        const fetchDashboardTitle = async () => {
          try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.DBL.GetDashboardById}?id=${rowid}`, {
              headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`
              }
            });
            
            if (response.data && response.data.success && response.data.data) {
              const dashboardTitle = response.data.data.name || response.data.data.title || response.data.data.dashboardName;
              if (dashboardTitle) {
                const updatedItems = buildBreadcrumbFromRoute(location.pathname);
                updatedItems.push({
                  label: dashboardTitle,
                  path: location.pathname,
                  isClickable: false
                });
                setBreadcrumbItems(updatedItems);
                return;
              }
            }
          } catch (error) {
            // If API call fails, fall back to DOM-based detection
            console.log('Failed to fetch dashboard title from API:', error);
          }
          
          // Fallback: Try to get from DOM after dashboard loads
          const updateBreadcrumbWithTitle = () => {
            const updatedItems = buildBreadcrumbFromRoute(location.pathname);
            setBreadcrumbItems(updatedItems);
          };
          
          setTimeout(updateBreadcrumbWithTitle, 500);
          setTimeout(updateBreadcrumbWithTitle, 1000);
          setTimeout(updateBreadcrumbWithTitle, 2000);
          
          // Also listen for DOM changes
          const observer = new MutationObserver(() => {
            updateBreadcrumbWithTitle();
          });
          
          const dashboardContainer = document.querySelector('.dx-dashboard, [class*="dashboard"]');
          if (dashboardContainer) {
            observer.observe(dashboardContainer, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class', 'data-dashboard-title']
            });
            
            // Disconnect after 5 seconds to avoid memory leaks
            setTimeout(() => observer.disconnect(), 5000);
          }
        };
        
        fetchDashboardTitle();
      }
    }
  }, [location.pathname, location.search, accessToken]);
  const LoginType = [
    { id: 1, name: 'Customer', value: 'A' },
    { id: 2, name: 'Consignee', value: 'B' },
    { id: 3, name: 'Carrier', value: 'C' },
    { id: 4, name: 'Internal User', value: 'D' },
  ];
  const getLoginType = () => {
    const foundType = LoginType.find(type => type.value === oidc.user.profile.LOGINTYPEID);
    return foundType ? foundType.name : 'Customer';
  };
  const getIdentityId = () => {
    if (oidc.user.profile && oidc.user.profile?.identityId !== null && oidc.user.profile?.identityId !== undefined) {
      return ` - ${oidc.user.profile.identityId}`;
    } else {
      return "";
    }
  };
  const handleClick = (e) => {
    // Handle DevExtreme Button event
    if (e && e.event) {
      e.event.stopPropagation();
      e.event.preventDefault();
    }
    // Handle regular click event
    if (e && e.stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    setMenuVisible(prev => !prev);
  };
  const handleClose = () => {
    setMenuVisible(false);
  };
  function delete_cookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  const openSettings = (e) => {
    history.push('/security/change-password');
    setMenuVisible(false);
  }
  const logoutUser = (e) => {
    var userManager = ReduxOidc.createUserManager(configuration.config);

    var id_token = props.oidc.user.id_token;
    var post_logout_redirect_uri = configuration.config.post_logout_redirect_uri;
    var userState = props.oidc.user?.state;

    clearAllChatMessages();

    // Clear every list page's remembered search so criteria never cross user sessions
    clearAllSearchStates();

    // Clear tab selection sessionStorage
    sessionStorage.removeItem('wm_selectedTabIndex');
    sessionStorage.removeItem('wm_history_selectedTabIndex');
    sessionStorage.removeItem('wm_inventory_selectedTabIndex');

    // remove cookies
    delete_cookie(".AspNetCore.Identity.Application");
    delete_cookie("idsrv.session");

    userManager.signoutRedirect({
      id_token_hint: id_token,
      post_logout_redirect_uri: post_logout_redirect_uri,
      state: userState
    }).then(() => {

      console.log('done signoutredirect');
    }).catch((error) => {
      console.error(error);
    });
  }
  const fetchVersionData = async () => {
    try {
      if (oidc.user.profile.webUserInfo) {
        const res = await axios.get(
          `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetApplicationVersionAndLastUpdated}`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        if (res.data) {
          setVersion(res.data.version);
          setLastUpdated(res.data.lastUpdated);
          
        } else {
          console.warn("No companies data available.");
        }
      }
    } catch (err) {
      console.log(err, "Error while getting databases");
    }
  };
  const fetchData = async () => {
    try {
      if (oidc.user.profile.webUserInfo) {
        const res = await axios.get(
          `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetDatabasesCompanies}?userId=${oidc.user.profile.sub}`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        if (res.data && res.data.companies.length > 0) {
          setFacilities(res.data.companies);
          
        } else {
          console.warn("No companies data available.");
        }
      }
    } catch (err) {
      console.log(err, "Error while getting databases");
    }
  };
  
  useEffect(() => {
    let webUserInfo = JSON.parse(oidc.user.profile.webUserInfo);
    setSelectedFacility(String(webUserInfo.userCompanyId))
  },[setFacilities]);
  

  useEffect(() => {
    fetchData();
    fetchVersionData();
    const storedSettings = localStorage.getItem(AppSettingsLocalStorageKey);
    if (storedSettings) {
        setSettings(JSON.parse(storedSettings));
    }
  }, []);
  const updateView = () => {
    setIsMobileView(window.innerWidth <= 804);  
  };

  useEffect(() => {
    updateView();
    window.addEventListener("resize", updateView);
    return () => {
      window.removeEventListener("resize", updateView);
    };
  }, []);


  const SyncFacility = (usercompanyid) => {
    let webUserInfoString = "";
    if (oidc.user.profile.webUserInfo) {
      let webUserInfo = JSON.parse(oidc.user.profile.webUserInfo);
      webUserInfo = {
        ...webUserInfo,
        userCompanyId: usercompanyid
      };

      webUserInfoString = JSON.stringify(webUserInfo);
    }

    var updateClaimObject = {
      UserId: oidc.user.profile.sub,
      Type: "webUserInfo",
      Value: webUserInfoString,
    };
    axios
      .post(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.UpdateClaim}`,
        updateClaimObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((result) => {
        window.location.reload();
      });
  };

  const OnFacilityChange = (event) => {
    if(event.previousValue != null && event.previousValue != undefined &&  event.previousValue != "-1")
    {
      setSelectedFacility(event.value);
      SyncFacility(event.value);
    }
  };

  const getInitials = (string) => {
    var initials = '';
    var names = string.split(' ');
    if (names.length > 0) {
      initials = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      else if (names[0].length >= 2) {
        initials += names[0].substring(1, 2).toUpperCase();
      }
    }
    return initials;
  };

  return (
    <div className="col-md-12 topbar-header p-2 d-flex" style={{ paddingLeft: '10px' }}>
      <Toolbar>
        <Item location="before">
          <Button stylingMode="contained" icon="dx-icon dx-icon-menu" onClick={props.minimizeSidebar}
            render={(buttonData) =>
              <i className="dx-icon dx-icon-menu" style={{ color: window._env_.Color1 }}></i>
            } />
        </Item>
        <Item location="before">
          <div className="logo">
             <img src={settings?.AppLogo==='../images/logo.png'? sitelogo:settings?.AppLogo}  alt="Argos" />
          </div>
        </Item>
        <Item location="before">
          <nav className="breadcrumb-nav">
            {breadcrumbItems.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="breadcrumb-separator">/</span>}
                {item.path && item.isClickable ? (
                  <a
                    href={item.path}
                    className="breadcrumb-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push(item.path);
                    }}
                  >
                    {item.label}
                  </a>
                ) : (
                  <span className={index === breadcrumbItems.length - 1 ? "breadcrumb-current" : "breadcrumb-text"}>
                    {item.label}
                  </span>
                )}
              </React.Fragment>
            ))}
          </nav>
        </Item>
        <Item location="after" visible={!isMobileView}>
        
          <SelectBox
            dataSource={facilities}
            value={selectedFacility}
            stylingMode="outlined"
            labelMode="static"
            label="Select Facility"
            displayExpr="text"
            valueExpr="value"
            style={{ width: "380px" }}
            placeholder='Loading...'
            onValueChanged={OnFacilityChange}
          >
          </SelectBox>
        </Item>
        <Item location="after" visible={!isMobileView}>
          <span style={{ fontSize: '16px',marginLeft:'5px' }}>{oidc.user.profile.name}</span>
        </Item>
        <Item location="after" >
          <div ref={menuRef} style={{ display: 'inline-block', position: 'relative' }}>
            {oidc.user.profile.user_image ?
              (<img src={`data:image/png;base64,${oidc.user.profile.user_image}`} className="user-image" alt="User" onClick={handleClick} style={{ cursor: 'pointer' }} />) :
              (
                <Button
                  onClick={handleClick}
                  icon="fa fa-user"
                  className="user-avatar-button"
                  stylingMode="text"
                >
                  <span className="user-avatar">
                    {oidc.user.profile.name?.substring(0, 2).toUpperCase()}
                  </span>
                </Button>
              )
            }
          </div>
        </Item>
      </Toolbar>
      <Popup
        visible={menuVisible}
        onHiding={handleClose}
        showTitle={false}
        width={200}
        height="auto"
        showCloseButton={false}
        position={menuRef.current ? { of: menuRef.current, offset: { x: 0, y: 30 }, at: "right top", my: "right top" } : { offset: { x: 0, y: 0 } }}
        hideOnOutsideClick={true}
        hideOnParentScroll={true}
        container=".dx-viewport"
        shading={false}
        dragEnabled={false}
        className="user-menu-popup"
      >
        <div style={{ padding: '0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '12px', borderBottom: '1px solid #e0e0e0' }}>
            {oidc.user.profile.user_image ?
              (<img src={`data:image/png;base64,${oidc.user.profile.user_image}`} style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                marginBottom: "12px",
                flexShrink: 0
              }} alt="User" />) :
              (
                <span className='user-avatar' style={{
                  marginBottom: "12px",
                  width: "36px",
                  height: "36px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "bold",
                  flexShrink: 0
                }}>
                  {oidc.user.profile.name?.substring(0, 2).toUpperCase()}
                </span>
              )
            }
            <div className="user-info" style={{ flex: 1, minWidth: 0 }}>
              <div className="user-details" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div className="user-name" style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '14px', lineHeight: '1.4' }}>{oidc.user.profile.name}</div>
                <div className="user-email" style={{ fontSize: '0.85em', color: '#666', marginBottom: '2px', lineHeight: '1.4' }}>{oidc.user.profile.email}</div>
                <div style={{ fontSize: '0.85em', marginBottom: '2px', lineHeight: '1.4' }}>
                  <span>{getLoginType()}</span>
                  {getIdentityId() && <span>{getIdentityId()}</span>}
                </div>
                <div className="user-email" style={{ fontSize: '0.8em', color: '#666', marginBottom: '2px', lineHeight: '1.4' }}>Last Update On: {lastUpdated}</div>
                <div className="user-email" style={{ fontSize: '0.8em', color: '#666', lineHeight: '1.4' }}>Version: {version}</div>
              </div>
            </div>
          </div>
          {isMobileView && (
            <div style={{ padding: '12px', borderBottom: '1px solid #e0e0e0' }}>
              <SelectBox
                items={locales}
                valueExpr="Value"
                displayExpr="Name"
                value={localeState}
                onValueChanged={changeLocale}
                inputAttr={selectBoxInputAttr}
                stylingMode="outlined"
                labelMode="static"
                label="Language"
                style={{ width: "100%", marginBottom: "10px" }}
              />
              <SelectBox
                dataSource={facilities}
                value={selectedFacility}
                stylingMode="outlined"
                labelMode="static"
                label="Select Facility"
                displayExpr="text"
                valueExpr="value"
                style={{ width: "100%" }}
                placeholder='Loading...'
                onValueChanged={OnFacilityChange}
              />
            </div>
          )}
          <Menu
            items={[
              { text: "Change Password", icon: "fa fa-key", onClick: openSettings },
              { text: "Log out", icon: "fa fa-sign-out", onClick: logoutUser }
            ]}
            orientation="vertical"
            cssClass="user-menu-items"
          />
        </div>
      </Popup>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(Header);
